import {DndContext, closestCenter, type DragEndEvent} from "@dnd-kit/core";
import {SortableContext, verticalListSortingStrategy, arrayMove} from "@dnd-kit/sortable";

interface Props<T> {
    items: T[];
    setItems: (items: T[]) => void;
    idKey: keyof T;
    renderItem: (item: T, index: number) => React.ReactNode;
}

function SortableList<T extends Record<string, any>>({
                                                         items,
                                                         setItems,
                                                         idKey,
                                                         renderItem
                                                     }: Props<T>) {

    const handleDragEnd = (event: DragEndEvent) => {

        const {active, over} = event;
        if (!over || active.id === over.id) return;

        const oldIndex = items.findIndex(i => i[idKey] === active.id);
        const newIndex = items.findIndex(i => i[idKey] === over.id);

        setItems(arrayMove(items, oldIndex, newIndex));
    };

    return (
        <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={items.map(i => i[idKey])} strategy={verticalListSortingStrategy}>
                {items.map((item, index) =>
                    renderItem(item, index)
                )}
            </SortableContext>
        </DndContext>
    );
}

export default SortableList;